import axios from "axios";
import { getAllTaskListingService, getAllTaskPriorityService, getAllTaskStatuService, getAllTaskTypeService, getPackingLabelsService, getShippedLabelHistoryService, getAllPackageTasksService, getAllProductTasksService } from "../../services/company.service";
import { FETCH_ALL_TASKS_LIST_STATUS_FAILED, FETCH_ALL_TASKS_LIST_STATUS_PENDING, FETCH_ALL_TASKS_LIST_STATUS_SUCCESS, FETCH_ALL_TASKS_PRIORITY, FETCH_ALL_TASKS_STATUS, FETCH_ALL_TYPE_STATUS, FETCH_PACKING_LABELS, FETCH_PACKING_LABELS_STATUS, FETCH_SHIPPED_LABEL_HISTORY, FETCH_SHIPPED_LABEL_HISTORY_STATUS } from "../types";
import { apiUrl } from "../../constant";


const getAllEmployeePermissionPending = () => ({
    type: FETCH_PACKING_LABELS_STATUS
});
const getAllEmployeePermissionSuccess = (response) => ({
    type: FETCH_PACKING_LABELS,
    payload: response,
});

export const getPackingLabels = (data) => {
    return (dispatch) => {
        dispatch(getAllEmployeePermissionPending());
        getPackingLabelsService(data).then((result) => {
            let addIdInList = result.data.EntityList.map((item, index) => {
                return {
                    ...item,
                    id: index + 1, // Adding a unique ID to each item
                };
            });
            let pickerList = {
                packingLabelList: addIdInList || [],
                TotalRecords: result.data.TotalRecords
            }
            dispatch(getAllEmployeePermissionSuccess(pickerList));
        }).catch((error) => {
            console.log(error)
        });
    };
};


const getShippedLabelHistoryPending = () => ({
    type: FETCH_SHIPPED_LABEL_HISTORY_STATUS
});
const getShippedLabelHistorySuccess = (response) => ({
    type: FETCH_SHIPPED_LABEL_HISTORY,
    payload: response,
});

export const getShippedLabelHistory = (data) => {
    return (dispatch) => {
        dispatch(getShippedLabelHistoryPending());
        getShippedLabelHistoryService(data).then((result) => {
            let addIdInList = result.data.EntityList.map((item, index) => {
                return {
                    ...item,
                    id: index + 1, // Adding a unique ID to each item
                };
            });
            let pickerList = {
                shippedLabelHistory: addIdInList || [],
                TotalRecords: result.data.TotalRecords
            }
            dispatch(getShippedLabelHistorySuccess(pickerList));
        }).catch((error) => {
            console.log(error)
        });
    };
};

export const updatePickedItemStatus = (data) => {
    return axios.post(`${apiUrl}/api/UpdatePickedItemStatus`, data);
};

// Per-scan: increments PickedQuantity by 1 on a single OutBoundItem,
// flips IsPicked = 1 only when the item's PickedQuantity reaches OrderedQuantity.
export const incrementPickedQuantity = (data) => {
    return axios.post(`${apiUrl}/api/IncrementPickedQuantity`, data);
};

export const getShippedLabelSummaryByOrderIds = (data) => {
    return axios.post(`${apiUrl}/api/GetShippedLabelSummaryByOrderIds`, data);
};

const getAllTaskPrioritySuccess = (response) => ({
    type: FETCH_ALL_TASKS_PRIORITY,
    payload: response,
});
const getAllTaskStatuSuccess = (response) => ({
    type: FETCH_ALL_TASKS_STATUS,
    payload: response,
});
const getAllTaskTypeSuccess = (response) => ({
    type: FETCH_ALL_TYPE_STATUS,
    payload: response,
});

export const getAllTaskPriority = (data) => {
    return (dispatch) => {
        getAllTaskPriorityService(data).then((result) => {
            dispatch(getAllTaskPrioritySuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error)
        });
    };
};
export const getAllTaskStatus = (data) => {
    return (dispatch) => {
        getAllTaskStatuService(data).then((result) => {
            dispatch(getAllTaskStatuSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error)
        });
    };
};
export const getAllTaskType = (data) => {
    return (dispatch) => {
        getAllTaskTypeService(data).then((result) => {
            dispatch(getAllTaskTypeSuccess(result.data.EntityList));
        }).catch((error) => {
            console.log(error)
        });
    };
};

export const createTask = (data) => {
    return axios.post(`${apiUrl}/api/TaskManagement/CreateTask`, data);
};
export const chargeSeller = (data) => {
    return axios.post(`${apiUrl}/api/TaskManagement/DebitTaskCost`, data);
};

export const updateTask = (data) => {
    return axios.put(`${apiUrl}/api/TaskManagement/UpdateTask`, data);
};

export const updateTaskAttachments = (data) => {
    return axios.put(`${apiUrl}/api/TaskManagement/UpdateTaskAttachments`, data);
};

export const getTaskById = (id) => {
    return axios.get(`${apiUrl}/api/TaskManagement/GetTask/${id}`);
};


const fetchTaskListingSuccess = (response) => ({
    type: FETCH_ALL_TASKS_LIST_STATUS_SUCCESS,
    payload: response,
});
const fetchTaskListingPending = () => ({
    type: FETCH_ALL_TASKS_LIST_STATUS_PENDING,
});
const fetchTaskListingFailed = () => ({
    type: FETCH_ALL_TASKS_LIST_STATUS_FAILED
});

export const getAllTaskListing = (data) => {
    return (dispatch) => {
        dispatch(fetchTaskListingPending());
        getAllTaskListingService(data).then((result) => {
            let data = {
                listTasks: result.data.EntityList || [],
                TotalRecords: result.data.TotalRecords
            };
            dispatch(fetchTaskListingSuccess(data));
        }).catch((error) => {
            dispatch(fetchTaskListingFailed());
        })
    };
};

// Shared helper for task-listing thunks. Calls the provided service, normalizes
// the response into { listTasks, TotalRecords } and dispatches the standard
// pending/success/fail actions used by the task listing reducer.
const dispatchTaskList = (serviceFn, data) => {
    return (dispatch) => {
        dispatch(fetchTaskListingPending());
        serviceFn(data).then((result) => {
            const payload = {
                listTasks: result.data.EntityList || [],
                TotalRecords: result.data.TotalRecords,
            };
            dispatch(fetchTaskListingSuccess(payload));
        }).catch(() => {
            dispatch(fetchTaskListingFailed());
        });
    };
};

export const getAllPackageTasks = (data) => dispatchTaskList(getAllPackageTasksService, data);

export const getAllProductTasks = (data) => dispatchTaskList(getAllProductTasksService, data);

export const handleDownloadFile = (data) => {
    return axios.get(`${apiUrl}/DownloadFile?fileUrl=${data}`, {
        responseType: 'blob'
    });
};
export const handleDownloadAllFiles = (data) => {
    return axios.post(`${apiUrl}/DownloadAllFiles`, data, {
        responseType: 'blob'
    });
};